<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("inventory.fields.region") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="regionFilter"
          :options="regionOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:regionFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("inventory.fields.municipality") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="municipalityFilter"
          :options="municipalityOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:municipalityFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.rems") }}</label>
        <b-form-input
          :value="remsFilter"
          type="number"
          min="0"
          class="w-100"
          :placeholder="$t('id') || 'ID'"
          @input="
            (v) => $emit('update:remsFilter', v !== '' && v != null ? Number(v) : null)
          "
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.sirh") }}</label>
        <b-form-input
          :value="sirhFilter"
          type="number"
          min="0"
          class="w-100"
          :placeholder="$t('id') || 'ID'"
          @input="
            (v) => $emit('update:sirhFilter', v !== '' && v != null ? Number(v) : null)
          "
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.unit_name") }}</label>
        <b-form-input
          :value="unitNameFilter"
          type="text"
          min="0"
          class="w-100"
          @input="(v) => $emit('update:unitNameFilter', v !== '' && v != null ? v : null)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("inventory.fields.unit_category") }}
        </label>
        <v-select
          data-cy="automatest-v-select-municipality"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="categoryFilter"
          :options="categoryOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:categoryFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.equipment_type") }}</label>
        <v-select
          data-cy="automatest-v-select-municipality"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="equipmentTypeFilter"
          :options="equipmentOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:equipmentTypeFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.brand") }}</label>
        <v-select
          data-cy="automatest-v-select-municipality"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="brandFilter"
          :options="brandOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:brandFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.model") }}</label>
        <b-form-input
          :value="modelFilter"
          type="text"
          min="0"
          class="w-100"
          @input="(v) => $emit('update:modelFilter', v !== '' && v != null ? v : null)"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.status") }}</label>
        <!--
        <b-form-input
          :value="statusFilter"
          type="text"
          min="0"
          class="w-100"
          @input="(v) => $emit('update:statusFilter', v !== '' && v != null ? v : null)"
        />
        -->
        <b-form-select
          :value="statusFilter"
          :options="statusOptions"
          @change="(v) => $emit('update:statusFilter', v !== '' && v != null ? v : null)"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("inventory.fields.installation_date")
        }}</label>
        <div class="input-group">
          <flat-pickr
            :value="installationDateFilter"
            class="form-control"
            @input="
              (v) =>
                $emit('update:installationDateFilter', v !== '' && v != null ? v : null)
            "
            :config="{
              //maxDate: new Date(),
              enableTime: false,
              dateFormat: 'Y-m-d',
              time_24hr: true,
              minuteIncrement: 1,
            }"
          />
          <div class="input-group-append">
            <button
              @click="handleClearInstallationDate()"
              class="btn btn-outline-primary"
              type="button"
            >
              x
            </button>
          </div>
        </div>
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("inventory.fields.depreciation_start_date")
        }}</label>
        <div class="input-group">
          <flat-pickr
            :value="depreciationStartDateFilter"
            class="form-control"
            @input="
              (v) =>
                $emit(
                  'update:depreciationStartDateFilter',
                  v !== '' && v != null ? v : null
                )
            "
            :config="{
              //maxDate: new Date(),
              enableTime: false,
              dateFormat: 'Y-m-d',
              time_24hr: true,
              minuteIncrement: 1,
            }"
          />
          <div class="input-group-append">
            <button
              @click="handleClearDepreciationStartDate()"
              class="btn btn-outline-primary"
              type="button"
            >
              x
            </button>
          </div>
        </div>
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.useful_life_months") }}</label>
        <b-form-input
          :value="usefulLifeMonthsFilter"
          type="number"
          min="0"
          class="w-100"
          @input="
            (v) =>
              $emit(
                'update:usefulLifeMonthsFilter',
                v !== '' && v != null ? Number(v) : null
              )
          "
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.remaining_life_months") }}</label>
        <b-form-input
          :value="remainingLifeMonthsFilter"
          type="number"
          min="0"
          class="w-100"
          @input="
            (v) =>
              $emit(
                'update:remainingLifeMonthsFilter',
                v !== '' && v != null ? Number(v) : null
              )
          "
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>{{ $t("inventory.fields.project") }}</label>
        <v-select
          data-cy="automatest-v-select-municipality"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="projectIdFilter"
          :options="projectOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:projectIdFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BFormInput,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";
import { reduce } from "lodash";
import defaultLayout from "@/config/defaultLayout";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormCheckbox,
    BFormInput,
    vSelect,
    flatPickr,
  },
  props: {
    regionOptions: {
      type: Array,
      default: () => [],
    },
    regionFilter: {
      type: Array,
      default: () => [],
    },
    categoryOptions: {
      type: Array,
      default: () => [],
    },
    categoryFilter: {
      type: Array,
      default: () => [],
    },
    unitOptions: {
      type: Array,
      default: () => [],
    },
    unitFilter: {
      type: Array,
      default: () => [],
    },
    userOptions: {
      type: Array,
      default: () => [],
    },
    userFilter: {
      type: Array,
      default: () => [],
    },
    countryOptions: {
      type: Array,
      default: () => [],
    },
    countryFilter: {
      type: Array,
      default: () => [],
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
    municipalityFilter: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    statusFilter: {
      type: Array,
      default: () => [],
    },
    responsableFilter: {
      type: Array,
      default: () => [],
    },
    assignedFilter: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    remsFilter: {
      type: [Number, String, null],
      default: null,
    },
    sirhFilter: {
      type: [Number, String, null],
      default: null,
    },
    unitNameFilter: {
      type: [String, null],
      default: null,
    },
    equipmentTypeFilter: {
      type: Array,
      default: [],
    },
    brandFilter: {
      type: Array,
      default: [],
    },
    modelFilter: {
      type: [String, null],
      default: null,
    },
    usefulLifeMonthsFilter: {
      type: [Number, String, null],
      default: null,
    },
    remainingLifeMonthsFilter: {
      type: [Number, String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    projectIdFilter: {
      type: Array,
      default: [],
    },
    projectNameFilter: {
      type: [String, null],
      default: null,
    },
    installationDateFilter: {
      type: String,
      default: null,
    },
    depreciationStartDateFilter: {
      type: String,
      default: null,
    },
    brandOptions: {
      type: Array,
      default: [],
    },
    projectOptions: {
      type: Array,
      default: [],
    },
    equipmentOptions: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClearInstallationDate() {
      this.$emit("update:installationDateFilter", null);
    },
    handleClearDepreciationStartDate() {
      this.$emit("update:depreciationStartDateFilter", null);
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.errorText {
  color: red;
  font-size: 12px;
}
</style>

